
import { Component, Vue } from 'nuxt-property-decorator'
import BlackFridayProvider from '~/components/black-friday/BlackFridayProvider.vue'
import { namespace as offerStore } from '~/store/modules/Offer'

const AVAILABLE_PROVIDERS = ['swisscom', 'salt', 'wingo', 'yallo', 'migros-mobile', 'quickline', 'talktalk', 'spusu', 'mtel']

@Component({
  components: {
    BlackFridayProvider,
  },
})
export default class BlackFridayProviders extends Vue {
  get providers () {
    return AVAILABLE_PROVIDERS.map((slug) => {
      const provider = this.$store.getters[`${offerStore}/getProviderBySlug`](slug)

      if (!provider) {
        return null
      }

      return {
        text: this.$t('blackFriday.providers.link', {
          name: provider.name,
        }),
        url: this.localePath({
          name: 'black-friday-slug',
          params: {
            slug: provider.slug,
          },
        }),
        imgSrc: provider.logo,
        linkText: this.$t('blackFriday.index.compare.button'),
        imgAlt: provider.name,
      }
    }).filter(Boolean)
  }
}
